import script from "./WidgetHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetHeader.vue?vue&type=script&setup=true&lang=js"

import "./WidgetHeader.vue?vue&type=style&index=0&id=348c0414&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-348c0414"]])

export default __exports__